//Created by wangshuyi on 2021/7/20.

'use strict';
export default {
  name: 'dol-button',
  functional: true,
  props: ['title'],
  render(h, { props, data, children }) {
    if(data.attrs){
      data.attrs.shape = data.attrs.shape || 'circle';
      data.attrs.size = data.attrs.size || 'small';
    }else if(data.props){
      data.props.shape = data.props.shape || 'circle';
      data.props.size = data.props.size || 'small';
    }else{
      data.props = {
        shape: 'circle',
        size: 'small',
      }
    }

    let button = h('a-button', data, children);
    if(props.title){
      return h('a-tooltip', {attrs: {title: props.title}}, [button])
    }else{
      return button;
    }
  }
}
